import React from 'react';
import { useNavigate } from 'react-router-dom';

import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import InfoIcon from '@mui/icons-material/Info';

import { Layout } from 'src/styles';

import AsmubipButton from './AsmubipButton';

export default function FlocosNoResultsCard() {
  const navigate = useNavigate();
  return (
    <Card sx={Layout.mobileCard} variant="outlined">
      <CardContent sx={Layout.productionCardContent}>
        <Box sx={Layout.productionCardIconWrapper}>
          <InfoIcon sx={Layout.productionCardIcon} />
        </Box>
        <Box>Não há nenhuma produção de flocos para este filtro!</Box>
      </CardContent>
      <CardActions>
        <AsmubipButton
          variant="contained-dark"
          size="large"
          sx={Layout.productionCardActionSingle}
          onClick={() => {
            navigate('/flocos_production/create');
          }}>
          Registrar nova produção
        </AsmubipButton>
      </CardActions>
    </Card>
  );
}
